import React, {useEffect, useState} from "react";
import {IonButtons, IonHeader, IonItem, IonItemGroup, IonModal, IonToolbar} from "@ionic/react";
import {UserPushNotificationStore, userStore} from "../../api/AuthService";
import {version as appVersion} from '../../Constants';

const PushNotificationWindow = (props: any) => {

    const [modalOpen, setModalOpen] = useState(true);
    const [pushData, setPushData] = useState<any>({});
    const [pushTitle, setPushTitle] = useState<any>({}); 
    const [pushBody, setPushBody] = useState<any>({});

    const sub = UserPushNotificationStore.subscribe((state: any) => setPushData(state.data))
    const sub2 = UserPushNotificationStore.subscribe((state: any) => setPushTitle(state.title))
    const sub3 = UserPushNotificationStore.subscribe((state: any) => setPushBody(state.body))


    const accept = (response: any, type: any) => {
        console.log("first response", response);
        if (type === 'delivery') {
            props.onAccept(response, type, pushData);
        } else if (type === 'ready') {
            props.onAccept(response, type, pushBody.replace("Trainee: ", ""))
        }
    }

    useEffect(() => {
        console.log("pushData", UserPushNotificationStore.getState());
      }, [pushData]);

    function getPushType() {
       console.log("pushType", pushTitle, pushBody)
       if (pushTitle === "Echo Test22") {
        return <IonItemGroup>
                    <IonItem lines="none" color="light">
                        <div style={{height: 'auto'}}>
                            <p style={{whiteSpace: "pre-line"}}>Your load is scheduled to be delivered on Monday. Please confirm you are good to make it on time.</p>
                        </div>
                    </IonItem>
                    <IonItem lines="none" color="light">
                        <div className="item-container">
                            <div style={{display: "flex"}}>
                                <button className="app-btn app-btn-primary w-100 text-center d-block" onClick={() => accept("yes", "delivery")}>Yes</button>
                                <button className="app-btn app-btn-primary w-100 text-center d-block" onClick={() => accept("no", "delivery")}>No</button>
                            </div>
                        </div>
                    </IonItem>
                </IonItemGroup>
       } else if (pushTitle === "Monday Delivery") {
        return <IonItemGroup>
                    <IonItem lines="none" color="light">
                        <div style={{height: 'auto'}}>
                            <p style={{whiteSpace: "pre-line"}}>Your load is scheduled to be delivered on Monday. Please confirm you are good to make it on time.</p>
                        </div>
                    </IonItem>
                    <IonItem lines="none" color="light">
                        <div className="item-container">
                            <div style={{display: "flex"}}>
                                <button className="app-btn app-btn-primary w-100 text-center d-block" onClick={() => accept("yes", "delivery")}>Yes</button>
                                <button className="app-btn app-btn-primary w-100 text-center d-block" onClick={() => accept("no", "delivery")}>No</button>
                            </div>
                        </div>
                    </IonItem>
                </IonItemGroup>
       } else if (pushTitle === "Ready for Solo?") {
        return <IonItemGroup>
            <IonItem lines="none" color="light">
                <div style={{height: 'auto'}}>
                    <p style={{whiteSpace: "pre-line"}}>Your trainee is close to completing their hours, and we see you have good reports submitted, do you think trainee {typeof pushBody === "string" ? pushBody.replace("Trainee: ", "") : null} is ready to graduate and seat solo?</p>
                </div>
            </IonItem>
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <div style={{display: "flex"}}>
                        <button className="app-btn app-btn-primary w-100 text-center d-block" onClick={() => accept("yes", "ready")}>Yes</button>
                        <button className="app-btn app-btn-primary w-100 text-center d-block" onClick={() => accept("no", "ready")}>No</button>
                    </div>
                </div>
            </IonItem>
        </IonItemGroup>
    } else {
        return
       }
    }

    return <IonModal isOpen={modalOpen} backdropDismiss={false} cssClass="block-modal">
         <div style={{display: "block"}}>
            <IonHeader>
            <IonToolbar color="primary">
                <IonButtons slot="start">
                <button onClick={ function() { props.cancel() }} style={{background: "transparent"}}>
                    <h6>X</h6>
                </button>
                </IonButtons>
                <IonItem style={{"--background": "#212121"}}>
                        <div className="item-container">
                            <h1 style={{color: "#fff"}}>{pushTitle === "Monday Delivery" ? "Monday Delivery" : pushTitle === "Ready for Solo?" ? "Ready for Solo?" : "Title"}</h1>
                        </div>
                </IonItem>
            </IonToolbar>
            </IonHeader>
        {getPushType()}
        </div>
    </IonModal>
}
export default PushNotificationWindow;
